import Who from './Who';
import WhoContainer from './Who.container';
import WhoPhase1 from './Who.actionbar_phase_1';
import { withFeatureBranch } from '../redux/flags';
var WhoComponent = withFeatureBranch({ actionbar_phase_1: WhoPhase1 })(Who);
export default WhoContainer(WhoComponent);
//# sourceMappingURL=index.js.map